import { resources } from "@constants/hardcoded-strings";
import { AxnAdminUserAccountStateTypes } from "@enums/axn-admin-user-account-state-types";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { replaceOrganizationUser } from "@redux/actions/organization-users-actions";
import { deleteAxnAdminUserRequest } from "@requests/axnadmin-core/delete-axn-admin-user-status";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";

export const deleteOrganizationUserReduxRequest = (dispatch: Dispatch) => async (
    userId: string,
): Promise<AxnAdminUser> => {
    const { data, error } = await deleteAxnAdminUserRequest(userId);
    if (data) {
        dispatch(replaceOrganizationUser(data.transferObject, AxnAdminUserAccountStateTypes.DELETE));
        return data.transferObject;
    } else {
        if (error) {
            const errorResource = resources.requests.deleteOrganizationUser.error;

            logAndDisplayErrorModal(
                dispatch,
                error,
                errorResource.title,
                errorResource.message
            );
        }
    }

    return null;
};